import { useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowDownUp, Trash2 } from "lucide-react";

interface ColumnsProps {
  onClickDelete: (data: any) => void;
}

const FactoryregistrationPaymentColumn = ({ onClickDelete }: ColumnsProps) => {
  const FactoryregistrationPaymentColumn = useMemo(
    () => [
      {
        header: "سال زراعی",
        accessorKey: "crop_year_name",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "عنوان",
        accessorKey: "title",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },

      {
        header: "نام کارخانه",
        accessorKey: "factory_name",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: () => (
          <div className="flex items-center gap-1">
            <span>
              مبلغ <span className="text-blue-600 text-[10px]">(ریال)</span>
            </span>
          </div>
        ),
        accessorKey: "price",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "تاریخ پرداخت",
        accessorKey: "date",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "تاریخ ثبت",
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },

      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <Link to="#" onClick={() => onClickDelete(cell.row.original)}>
              <span className="rounded p-2 w-20 ml-3 bg-red-700 text-white">
                حذف
              </span>
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  return FactoryregistrationPaymentColumn;
};

export default FactoryregistrationPaymentColumn;
